import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

export const NEW_VISIT_FORM_VERSION = 2;
export const FOLLOW_UP_FORM_VERSION = 2;

export function useFormVersionTag(formType: string, formVersion: number) {
  useEffect(() => {
    Sentry.setTags({ formType, formVersion });
  }, [formType, formVersion]);
}
